import React from 'react';
import { Typography, Chip, Tooltip } from '@mui/material';

interface ClampedTextProps {
  text: string | null | undefined;
  lines?: number;
}

export const ClampedText = ({ text, lines = 2 }: ClampedTextProps) => {
  if (!text) {
    return (
      <Chip
        size="small"
        label="Sin Datos"
        sx={{ color: '#4c64ffff', background: '#FFE2E3', fontWeight: 700 }}
      />
    );
  }

  const clampStyles =
    lines > 0
      ? {
          display: '-webkit-box',
          WebkitLineClamp: lines,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }
      : {};

  return (
    <Tooltip
      title={text}
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: '0.95rem',
            padding: '10px 14px',
            lineHeight: 1.5,
            maxWidth: 450,
            bgcolor: '#2e263d',
            color: 'white',
            boxShadow: 4,
          },
        },
      }}
    >
      <Typography
        variant="body1"
        sx={{
          ...clampStyles,
          color: 'text.primary',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '0.95rem',
          cursor: lines > 0 ? 'pointer' : 'inherit',
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};
